// extracted by mini-css-extract-plugin
export default {"banner":"S2TJP4CR4hTv8z_ai6Vn"};